export default __webpack_public_path__ + "static/Entenda0094-479882c293d08709a0dcab29d7210712.jpg";